/* eslint-disable max-classes-per-file */
interface UsefulInterface {
  group: string;
  detail: string[];
}

interface UsefulDetailInterface {
  groupId: number;
  groupName: string;
  details: string[];
}

interface FacilitiesDetailInterface {
  groupId: number;
  groupName: string;
  details: {
    id: number;
    name: string;
  }[];
}
export class ReviewClass {
  addressObj: {
    street1: string;
    street2: string;
    city: string;
    state: string;
    country: string;
    postalcode: number;
    addressString: string;
  };

  timezone: string;

  latitude: number;

  rating: number;

  locationId: number;

  tripTypes: {
    name: string;
    value: string;
    localizedName: string;
  }[];

  reviews: HotelDetailReviewInterface[];

  writeReview: string;

  ancestors: {
    abbrv: string;
    level: string;
    name: string;
    locationId: number;
  }[];

  brand: string;

  longitude: number;

  hours: number;

  percentRecommended: number;

  hotelBooking: {
    bookable: boolean;
    bookingUrl: string;
  };

  parentBrand: string;

  reviewRatingCount: ReviewRatingCountInterface;

  subratings: {
    ratingImageUrl: string;
    name: string;
    value: string;
    localizedName: string;
  }[];

  rankingData: {
    rankingString: string;
    rankingOutOf: number;
    geoLocationId: number;
    ranking: number;
    geoLocationName: string;
    rankingStringDetail: string;
  };

  constructor(data: any) {
    this.addressObj = {
      street1: data?.address_obj?.street1 || "",
      street2: data?.address_obj?.street2 || "",
      city: data?.address_obj?.city || "",
      state: data?.address_obj?.state || "",
      country: data?.address_obj?.country || "",
      postalcode: data?.address_obj?.postalcode || "",
      addressString: data?.address_obj?.address_string || "",
    };
    this.timezone = data?.timezone || "";
    this.latitude = data?.latitude || 0;
    this.rating = data?.rating || 0;
    this.locationId = data?.location_id || 0;
    this.tripTypes = (data?.trip_types || []).map((item: any) => {
      return {
        name: item?.name || "",
        value: item?.value || "",
        localizedName: item?.localized_name || "",
      };
    });
    this.reviews = (data?.reviews || []).map((item: any) => {
      return {
        id: item?.id || 0,
        lang: item?.lang || "",
        locationId: item?.location_id || 0,
        publishedDate: item?.published_date || "",
        rating: item?.rating || 0,
        helpfulVotes: item?.helpful_votes || "",
        ratingImageUrl: item?.rating_image_url || "",
        url: item?.url || "",
        tripType: item?.trip_type || "",
        travelDate: item?.travel_date || "",
        text: item?.text || "",
        user: {
          username: item?.user.username || "",
          userLocation: {
            name: item?.user.user_location?.name ?? "",
            id: item?.user.user_location?.id ?? 0,
          },
        },
        title: item?.title || "",
        isMachineTranslated: item?.is_machine_translated || false,
      };
    });

    this.writeReview = data?.write_review || "";
    this.ancestors = (data?.ancestors || []).map((item: any) => {
      return {
        abbrv: item?.abbrv || "",
        level: item?.level || "",
        name: item?.name || "",
        locationId: item?.location_id || 0,
      };
    });
    this.brand = data?.brand || "";
    this.longitude = data?.longitude || 0;
    this.hours = data?.hours || 0;
    this.percentRecommended = data?.percent_recommended || 0;
    this.hotelBooking = {
      bookable: data?.hotel_booking?.bookable || false,
      bookingUrl: data?.hotel_booking?.booking_url || "",
    };
    this.parentBrand = data?.parent_brand || "";
    this.reviewRatingCount = {
      1: data?.review_rating_count?.["1"] || "",
      2: data?.review_rating_count?.["2"] || "",
      3: data?.review_rating_count?.["3"] || "",
      4: data?.review_rating_count?.["4"] || "",
      5: data?.review_rating_count?.["5"] || "",
    };
    this.subratings = (data?.subratings || []).map((item: any) => {
      return {
        ratingImageUrl: item.rating_image_url || "",
        name: item?.name || "",
        value: item?.value || "",
        localizedName: item?.localized_name || "",
      };
    });
    this.rankingData = {
      rankingString: data?.ranking_data?.ranking_string || "",
      rankingOutOf: data?.ranking_data?.ranking_out_of || 0,
      geoLocationId: data?.ranking_data?.geo_location_id || 0,
      ranking: data?.ranking_data?.ranking || 0,
      geoLocationName: data?.ranking_data?.geo_location_name || "",
      rankingStringDetail: data?.ranking_data?.ranking_string_detail || "",
    };
  }
}
interface AmenitiesDetailInterface {
  any: any;
}

export interface RequestHotelDetailInterface {
  hotelId: number;
}
export interface RequestHotelDetailBySlugInterface {
  countrySlug: string;
  citySlug: string;
  areaSlug: string;
  hotelSlug: string;
}

interface GreenCertification {
  id: number;
  nameEn: string;
  nameTh: string;
}

export interface ResponseHotelDetailInterface {
  id: number;
  name: string;
  description: string;
  starRating: number;
  latitude: number;
  longitude: number;
  phoneNumber: string;
  faxNumber: string;
  address: string;
  countryName: string;
  cityName: string;
  areaName: string;
  destinationId: number;
  photoGallery: string[];
  useful: UsefulInterface[];
  facilities: string[];
  amenities: string[];
  usefulDetail: UsefulDetailInterface[];
  facilitiesDetail: FacilitiesDetailInterface[];
  amenitiesDetail: AmenitiesDetailInterface[];
  important_note: string;
  observation: string;
  isRegister: boolean;
  isThaiHotelMember: boolean;
  shaPlus: boolean;
  shaExtraPlus: boolean;
  review: any;
  isGreenCertificate: boolean;
  greenCertifications: GreenCertification[];
}
export class ResponseHotelGetDetail {
  id: number;

  name: string;

  description: string;

  starRating: number;

  latitude: number;

  longitude: number;

  phoneNumber: string;

  faxNumber: string;

  address: string;

  countryName: string;

  cityName: string;

  areaName: string;

  isGreenCertificate: boolean;

  greenCertifications: GreenCertification[];

  destinationId: number;

  photoGallery: string[];

  useful: {
    group: string;
    detail: string[];
  };

  facilities: {
    id: number;
    image: string;
    name: string;
  }[];

  amenities: string[];

  usefulDetail: {
    groupId: number;
    groupName: string;
    details: string[];
  };

  facilitiesDetail: {
    groupId: number;
    groupName: string;
    details: {
      id: number;
      name: string;
      image: string;
    }[];
  }[];

  amenitiesDetail: {
    any: any;
  };

  important_note: string;

  observation: string;

  isRegister: boolean;

  isThaiHotelMember: boolean;

  shaPlus: boolean;

  shaExtraPlus: boolean;

  isFavourite: boolean;

  review: Review;

  countrySlug: string;

  citySlug: string;

  areaSlug: string;

  slug: string;

  hotelSlugPath: string;

  // num_reviews?:number;
  constructor(data: any) {
    this.id = data.id || 0;
    this.name = data.name || "";
    this.description = data.description || "";
    this.starRating = data.starRating || 0;
    this.latitude = data.latitude || 0;
    this.longitude = data.longitude || 0;
    this.phoneNumber = data.phoneNumber || "";
    this.faxNumber = data.faxNumber || "";
    this.address = data.address || "";
    this.countryName = data.countryName || "";
    this.cityName = data.cityName || "";
    this.areaName = data.areaName || "";
    this.destinationId = data.destinationId || 0;
    this.photoGallery = data.photoGallery || "";
    this.isFavourite = data.isFavourite || false;
    this.useful = {
      group: data.useful?.group || null,
      detail: data.useful?.detail || null,
    };

    this.facilities = (data.facilities || []).map((item: any) => {
      return {
        id: item.id || 0,
        image: item.image || "",
        name: item.name || "",
      };
    });
    this.amenities = data.amenities || "";
    this.usefulDetail = {
      groupId: data.usefulDetail?.groupId || 0,
      groupName: data.usefulDetail?.groupName || "",
      details: data.usefulDetail?.details || "",
    };
    this.facilitiesDetail = (data.facilitiesDetail || []).map((item: any) => {
      return {
        groupId: item.groupId || 0,
        groupName: item.groupName || "",
        details: (item.details || []).map((item_2: any) => {
          return {
            id: item_2.id || 0,
            name: item_2.name || "",
            image: item_2.image || "",
          };
        }),
      };
    });
    this.amenitiesDetail = {
      any: data.amenitiesDetail?.any || "",
    };
    this.important_note = data.important_note || "";
    this.observation = data.observation || "";
    this.isRegister = data.isRegister || false;
    this.isThaiHotelMember = data.isThaiHotelMember || false;
    this.shaPlus = data.shaPlus || false;
    this.shaExtraPlus = data.shaExtraPlus || false;

    this.review = new ReviewClass(data?.review) || new ReviewClass({});

    this.greenCertifications = (data?.greenCertifications || []).map(
      (item: any) => {
        return {
          id: item.id || 0,
          nameEn: item.nameEn || "",
          nameTh: item.nameTh || "",
        };
      },
    );

    this.countrySlug = data.countrySlug;
    this.citySlug = data.citySlug;
    this.areaSlug = data.areaSlug;
    this.slug = data.slug;
    this.hotelSlugPath = `/${this.countrySlug}/${this.citySlug}/${this.areaSlug}/${this.slug}`;
    this.isGreenCertificate = data.isGreenCertificate || false;
  }
}

export interface RequestHotelNearByInterface {
  hotel_id: number;
}
export class ResponseHotelNearByClass {
  contents: {
    distance: number;
    label: string;
  }[];

  header: string;

  icon: string;

  constructor(data: any) {
    this.contents = data.contents || [];
    this.header = data.header || "";
    this.icon = data.icon || "";
  }
}

export class ResponseHotelGetPhotoGallery {
  photos: string[];

  name: string;

  starRating: number;

  constructor(data: any) {
    this.photos = data.photos || [];
    this.name = data.name || "";
    this.starRating = data.starRating || 0;
  }
}

export interface HotelDetailReviewInterface {
  id: number;
  lang: string;
  locationId: number;
  publishedDate: string;
  rating: number;
  helpfulVotes: string;
  ratingImageUrl: string;
  url: string;
  tripType: string | null;
  travelDate: string;
  text: string;
  user: {
    username: string;
    userLocation: {
      name: string;
      id: number | null;
    };
  };
  title: string;
  isMachineTranslated: boolean;
}
export interface Review {
  addressObj: {
    street1: string;
    street2: string;
    city: string;
    state: string;
    country: string;
    postalcode: number;
    addressString: string;
  };
  timezone: string;
  latitude: number;
  rating: number;
  locationId: number;
  tripTypes: {
    name: string;
    value: string;
    localizedName: string;
  }[];
  reviews: HotelDetailReviewInterface[];
  writeReview: string;
  ancestors: {
    abbrv: string;
    level: string;
    name: string;
    locationId: number;
  }[];
  brand: string;
  longitude: number;
  hours: number;
  percentRecommended: number;
  hotelBooking: {
    bookable: boolean;
    bookingUrl: string;
  };
  parentBrand: string;
  reviewRatingCount: ReviewRatingCountInterface;
  subratings: {
    ratingImageUrl: string;
    name: string;
    value: string;
    localizedName: string;
  }[];
  rankingData: {
    rankingString: string;
    rankingOutOf: number;
    geoLocationId: number;
    ranking: number;
    geoLocationName: string;
    rankingStringDetail: string;
  };
}

export class ResponseHotelGetReview {
  review: Review;

  constructor(data: any) {
    this.review = new ReviewClass(data);
  }
}

export interface ReviewRatingCountInterface {
  1: string;
  2: string;
  3: string;
  4: string;
  5: string;
}
export interface ReviewRatingCountPercentInterface {
  1: string | number;
  2: string | number;
  3: string | number;
  4: string | number;
  5: string | number;
}
